module.exports = __webpack_public_path__ + "img/big-chevron.b44c85eb.png";